import { type FunctionComponent, type PropsWithChildren, createContext, useRef, useState } from 'react';
import { type CurrentStepData } from '../../../types/project-tour.types';

export type ProjectsTourContextState = {
	currentStep: CurrentStepData;
	setCurrentStep: React.Dispatch<React.SetStateAction<CurrentStepData>>;
	currentStepRef: React.RefObject<HTMLDivElement> | null;
	currentStepRefMobile: React.RefObject<HTMLDivElement> | null;
	spotlightRef: React.RefObject<HTMLDivElement> | null;
	spotlightRefMobile: React.RefObject<HTMLDivElement> | null;
	tourStartRef: React.RefObject<HTMLDivElement> | null;
};

const initialState: ProjectsTourContextState = {
	currentStep: { currentStepId: null, currentStepIndex: -1 },
	setCurrentStep: () => {},
	currentStepRef: null,
	currentStepRefMobile: null,
	spotlightRef: null,
	spotlightRefMobile: null,
	tourStartRef: null
};

export const ProjectsTourContext = createContext<ProjectsTourContextState>(initialState);

export const ProjectsTourContextProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
	const [currentStep, setCurrentStep] = useState<CurrentStepData>({ currentStepId: null, currentStepIndex: -1 });

	const currentStepRef = useRef<HTMLDivElement>(null);
	const currentStepRefMobile = useRef<HTMLDivElement>(null);
	const spotlightRef = useRef<HTMLDivElement>(null);
	const spotlightRefMobile = useRef<HTMLDivElement>(null);
	const tourStartRef = useRef<HTMLDivElement>(null);

	const value = {
		currentStep,
		setCurrentStep,
		currentStepRef,
		currentStepRefMobile,
		spotlightRef,
		spotlightRefMobile,
		tourStartRef
	};

	return <ProjectsTourContext.Provider value={value}>{children}</ProjectsTourContext.Provider>;
};
